import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthUserInterface, AuthUserInterfaceWithId } from '@sk/sk-interfaces';
import { fromPromise } from 'rxjs/internal-compatibility';
import  firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthUserService {

  constructor(private firestoreService: AngularFirestore,
              private authService: AngularFireAuth) {
  }

  // Used by Client Revoke access and Staff Revoke Access
  getAuthUserByEmail(email): Observable<AuthUserInterfaceWithId[]> {
    return this.firestoreService.collection('users', ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('email', '==', email);
      return query;
    }).snapshotChanges()
      .pipe(
        map(actions => actions.map(a => {
          const data = a.payload.doc.data() as AuthUserInterface;
          const id = a.payload.doc.id;
          const exists = a.payload.doc.exists;
          return {...data, id, exists } as AuthUserInterfaceWithId;
        }))
      );
  }

  // Used by Client Revoke access and Staff Revoke Access
  updateAuthUser(authUser: AuthUserInterfaceWithId) {
    const id = authUser.id
    const user = {
      ...authUser
    }
    delete user.id;
    delete user.exists;
    return fromPromise(this.firestoreService
      .collection('users').doc(id).update(user));
  }


  authStateListener(): Observable<firebase.User | null> {
    return this.authService.authState;
  }


  getIdToken(): Observable<firebase.auth.IdTokenResult> {
    return this.authService.idTokenResult;
  }



}
